import axios from "axios";
import { useCallback, useContext, useState } from "react";
import { GlobalStates } from "../GlobalStates";

export const useStrapiObjectClass = (options, defaultValue = {}) => {
    const { token, path } = useContext(GlobalStates);
    const { name, path: url = path, extraFilter = '',setter=()=>{} } = options;
    const [data, setData] = useState(defaultValue);

    const getAll = useCallback(async (what = name + '?pagination[start]=0&pagination[limit]=9999999&populate=*') => {
        axios
            .get(url + what + extraFilter, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then((response) => {
                setData(response.data.data)
                setter(response.data.data.map(data =>{
                    return {id:data.id,...data.attributes}
                }))
                return response.data.data
            })
            .catch((error) => {
                console.log('An error occurred:', error);
            });
    }, [name, url, token, extraFilter]);

    const getSingle = useCallback(async (id, setter) => {
        axios
            .get(url + name + '/' + id + '?' + extraFilter, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then((response) => {
                if (setter)
                    setter(response.data.data)
                else
                    setData(response.data.data)
                return response.data.data
            })
            .catch((error) => {
                console.log('An error occurred:', error);
            });
    }, [name, token, url]);

    const update = useCallback(async (id, info, setter) => {
        try {
            var fe = await fetch(url + name + '/' + id, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(
                    {
                        data: info
                    }
                ),
            })
            if (setter)
                setter(await fe.json())
            console.log(fe)
            // return fe.json()
        }
        catch (e) { console.log(e) }
    }, [name, token, url])

    const DELETE = useCallback(async (id, getAll) => {
        return fetch(url + name + '/' + id, {
            method: 'DELETE',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        }).then((response) => {
            console.log(response.json());
            if (getAll)
                getAll()
            return true
        }).catch((e) => { console.log(e); })
    }, [name, token, url]);

    const create = useCallback(async (info = {}) => {
        try {
            var fe = await fetch(url + name, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ data: info }),
            })
            var jsonn = await fe.json()
            if (jsonn?.error?.status == 400) {
                var errorsM = ''
                if (jsonn.error.details?.errors?.length > 0) {
                    jsonn.error.details.errors.map(e => {
                        errorsM += (e.message + '\n')
                    })
                }
                else errorsM = jsonn.error.message
                alert(errorsM)
            }
            return jsonn
        }
        catch (e) {
            console.log(e);
            alert(e)
        }
    }, [name, token, url])
    const addImages = useCallback(async (images, id, type) => {
        const formData = new FormData();
        images.forEach(img => {
            console.log(images.length, img, name)
            formData.append("files", img.file, img.name);
        })

        formData.append("ref", "api::" + name + "." + name);
        formData.append("refId", id);
        formData.append("field", type);
        try {
            if (images.length > 0) {
                const res = await fetch(`${path}upload`, {
                    method: "POST",
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    },
                    body: formData,
                });
                await res.json().then(data => console.log(data))
                return res
            }
            return false
        } catch (error) {
            console.error("error while adding images to post", error)
            return error.response
        }
    }, [name, token, url])
    const deleteImages = async (path, id) => {
        try {
            const res = await fetch(`${path}upload/files/` + id, {
                method: "DELETE",
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });
            return true
        }
        catch (e) { console.log(e) }
    }

    return {
        data,
        getSingle,
        getAll,
        update,
        DELETE,
        create,
        addImages,
        deleteImages,

    }
}
